import type { MessageDescriptor } from 'react-intl';
import type { AppSketch, SketchViewer } from '@api/appBuilder';

export const SKETCH_STEP_MS = 3800;
export const SKETCH_WAIT_MS = 6_000;
export const SKETCH_NARROW_PX = 600;
export const SKETCH_GUIDE_PX = 160;
export const SKETCH_GUIDE_NARROW_PX = 110;

export const GENERIC_SKETCH: AppSketch = {
  viewers: ['generic'],
  controls: [
    { label: 'Size', kind: 'slider' },
    { label: 'Option', kind: 'select' },
  ],
};

export const VIEWER_NAMES: Readonly<Record<SketchViewer, MessageDescriptor>> = {
  model: { id: 'apps.builder.sketch.viewer.model', defaultMessage: 'the 3D viewer' },
  room: { id: 'apps.builder.sketch.viewer.room', defaultMessage: 'the 3D room' },
  simulation: { id: 'apps.builder.sketch.viewer.simulation', defaultMessage: 'the 3D simulation' },
  image: { id: 'apps.builder.sketch.viewer.image', defaultMessage: 'the image viewer' },
  chart: { id: 'apps.builder.sketch.viewer.chart', defaultMessage: 'the chart' },
  document: { id: 'apps.builder.sketch.viewer.document', defaultMessage: 'the results document' },
  drawing: { id: 'apps.builder.sketch.viewer.drawing', defaultMessage: 'the drawing sheet' },
  generic: { id: 'apps.builder.sketch.viewer.generic', defaultMessage: 'the main view' },
};

export const SKETCH_MESSAGES = {
  reading: { id: 'apps.builder.sketch.reading', defaultMessage: 'Reading your brief…' },
  viewer: { id: 'apps.builder.sketch.viewer', defaultMessage: 'Sketching {viewers}…' },
  control: { id: 'apps.builder.sketch.control', defaultMessage: 'Adding a control for {label}…' },
  export: { id: 'apps.builder.sketch.export', defaultMessage: 'Adding the export button…' },
  build: { id: 'apps.builder.sketch.build', defaultMessage: 'That is the plan. Now we are building it for real…' },
  and: { id: 'apps.builder.sketch.and', defaultMessage: '{first} and {second}' },
  exportLabel: { id: 'apps.builder.sketch.exportLabel', defaultMessage: 'Export' },
  controls: { id: 'apps.builder.sketch.controls', defaultMessage: 'Controls' },
  stop: { id: 'apps.builder.progress.stop', defaultMessage: 'Stop' },
  skip: { id: 'apps.builder.sketch.skip', defaultMessage: 'Skip sketch' },
} as const satisfies Record<string, MessageDescriptor>;
